var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6957 13.3139L17.6457 8.36388C17.7379 8.26837 17.8482 8.19219 17.9703 8.13978C18.0923 8.08737 18.2235 8.05979 18.3563 8.05863C18.489 8.05748 18.6207 8.08278 18.7436 8.13306C18.8665 8.18334 18.9782 8.25759 19.0721 8.35149C19.1659 8.44538 19.2402 8.55703 19.2905 8.67993C19.3408 8.80282 19.3661 8.9345 19.3649 9.06728C19.3638 9.20006 19.3362 9.33128 19.2838 9.45329C19.2313 9.57529 19.1552 9.68564 19.0597 9.77788L13.4027 15.4349C13.2151 15.6224 12.9608 15.7277 12.6957 15.7277C12.4305 15.7277 12.1762 15.6224 11.9887 15.4349L6.33166 9.77788C6.23615 9.68564 6.15996 9.57529 6.10755 9.45329C6.05514 9.33128 6.02756 9.20006 6.0264 9.06728C6.02525 8.9345 6.05055 8.80282 6.10083 8.67993C6.15111 8.55703 6.22537 8.44538 6.31926 8.35149C6.41315 8.25759 6.52481 8.18334 6.6477 8.13306C6.7706 8.08278 6.90228 8.05748 7.03506 8.05863C7.16784 8.05979 7.29906 8.08737 7.42106 8.13978C7.54306 8.19219 7.65341 8.26837 7.74566 8.36388L12.6957 13.3139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.83e62d083901bc6628032353d1b68cf0.svg";
export { ForwardRef as ReactComponent };